// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.post-list {
    padding: 0;
    margin: 0 auto;
    max-width: 700px;
}
.post-list .post-list__header {
    display: grid;
    grid-template-columns: 1fr 1fr;

    max-width: 650px;
    margin: 20px auto 20px auto;
    width: 100%;
    box-sizing: border-box;
}
.post-list .post-list__header__controls {
    text-align: right;
}
.post-list .post-list__header__explanation {
    align-self: center;
    text-align: left;
    padding-left: 7px;
}
`, "",{"version":3,"sources":["webpack://./client/components/posts/PostList/PostList.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,8BAA8B;;IAE9B,gBAAgB;IAChB,2BAA2B;IAC3B,WAAW;IACX,sBAAsB;AAC1B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB","sourcesContent":[".post-list {\n    padding: 0;\n    margin: 0 auto;\n    max-width: 700px;\n}\n.post-list .post-list__header {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n\n    max-width: 650px;\n    margin: 20px auto 20px auto;\n    width: 100%;\n    box-sizing: border-box;\n}\n.post-list .post-list__header__controls {\n    text-align: right;\n}\n.post-list .post-list__header__explanation {\n    align-self: center;\n    text-align: left;\n    padding-left: 7px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
